import React from 'react';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { whatsappLink, brand } from '../data/mock';

const FooterLogo = () => (
  <a href="#top" className="flex items-center gap-3 select-none">
    <img
      src={brand.logo}
      alt="BRN"
      className="h-14 w-auto"
      style={{ filter: 'invert(1) brightness(1.1)' }}
    />
    <span className="font-italiana text-[14px] tracking-[0.4em] text-cream/85 mt-1">BARBEARIA</span>
  </a>
);

const Footer = () => {
  return (
    <footer className="relative bg-grid border-t border-cream/10">
      <div className="max-w-6xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* About */}
          <div className="md:col-span-5">
            <FooterLogo />
            <p className="mt-7 text-cream-soft text-[14.5px] leading-relaxed max-w-md">
              Não é sobre cortar cabelo. É sobre experiência, identidade e padrão. Transformamos minutos de
              cuidado em confiança para homens que querem mais.
            </p>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="mt-7 inline-flex items-center gap-2 rounded-full border border-cream/25 px-6 py-2.5 text-[13px] text-cream hover:bg-cream hover:text-[#0b0807] transition-colors"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-cream" />
              Agendar
            </a>
          </div>

          {/* Servicos */}
          <div className="md:col-span-3">
            <h4 className="text-cream text-[15px] font-medium mb-5">Serviços</h4>
            <ul className="space-y-3 text-[13.5px] text-cream-soft">
              <li><a href="#servicos" className="hover:text-cream transition-colors">Corte</a></li>
              <li><a href="#servicos" className="hover:text-cream transition-colors">Barba</a></li>
              <li><a href="#servicos" className="hover:text-cream transition-colors">Corte + Barba</a></li>
              <li><a href="#servicos" className="hover:text-cream transition-colors">Sobrancelha</a></li>
              <li><a href="#servicos" className="hover:text-cream transition-colors">Barboterapia</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="text-cream text-[15px] font-medium mb-5">Contato</h4>
            <ul className="space-y-4 text-[13.5px] text-cream-soft">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-cream/70 flex-shrink-0" />
                <span>{brand.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-cream/70 flex-shrink-0" />
                <a href={whatsappLink} target="_blank" rel="noreferrer" className="hover:text-cream">{brand.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-cream/70 flex-shrink-0" />
                <a href={`mailto:${brand.email}`} className="hover:text-cream break-all">{brand.email}</a>
              </li>
              <li>
                <a
                  href={brand.instagramUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-start gap-3 hover:text-cream transition-colors group"
                >
                  <Instagram className="w-4 h-4 mt-0.5 text-cream/70 group-hover:text-cream flex-shrink-0" />
                  <span className="underline-offset-4 group-hover:underline">@{brand.instagram}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-[12.5px] text-cream/60">
            © {new Date().getFullYear()} BRN Barbearia. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-2">
            <a
              href={brand.instagramUrl}
              target="_blank"
              rel="noreferrer"
              className="w-9 h-9 rounded-full border border-cream/15 flex items-center justify-center text-cream/75 hover:bg-cream hover:text-[#0b0807] transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href={`mailto:${brand.email}`}
              className="w-9 h-9 rounded-full border border-cream/15 flex items-center justify-center text-cream/75 hover:bg-cream hover:text-[#0b0807] transition-colors"
              aria-label="E-mail"
            >
              <Mail className="w-4 h-4" />
            </a>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="w-9 h-9 rounded-full border border-cream/15 flex items-center justify-center text-cream/75 hover:bg-cream hover:text-[#0b0807] transition-colors"
              aria-label="WhatsApp"
            >
              <Phone className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
